import { useTranslation } from 'react-i18next';
import classes from './List.module.scss';

const list = [
    {
        subtitle: 'electrical.list.li_01.subtitle',
        desc: 'electrical.list.li_01.desc',
    },
    {
        subtitle: 'electrical.list.li_02.subtitle',
        desc: 'electrical.list.li_02.desc',
    },
    {
        subtitle: 'electrical.list.li_03.subtitle',
        desc: 'electrical.list.li_03.desc',
    },
    {
        subtitle: 'electrical.list.li_04.subtitle',
        desc: 'electrical.list.li_04.desc',
    },
    {
        subtitle: 'electrical.list.li_05.subtitle',
        desc: 'electrical.list.li_05.desc',
    },
    {
        subtitle: 'electrical.list.li_06.subtitle',
        desc: 'electrical.list.li_06.desc',
    },
];

const List = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <h2 className={`${classes.title} font-48`}>
                    {t('electrical.list.title')}
                </h2>
                <ul className={`${classes.list} font-16`}>
                    {list.map((li, index) =>
                        <li key={index}>
                            <h4 className={`${classes.subtitle} font-20`}>
                                {t(li.subtitle)}
                            </h4>
                            <p className={`${classes.desc} font-16`}>
                                {t(li.desc)}
                            </p>
                        </li>
                    )}
                </ul>
            </div>
        </section>
    );
};

export default List;
